/* ==========================================================================
   pdp-nutrilax.js
   ========================================================================== */

var NLX_T = (window.__NLX && window.__NLX.t) || {};
function nlxFmt(s, o) {
  return String(s || '').replace(/\{(\w+)\}/g, function (m, k) { return k in o ? o[k] : m; });
}

(function () {
  try {
    var tl = document.getElementById('nl-tl');
    if (!tl || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    tl.classList.add('is-armed');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -15% 0px' });
    [].forEach.call(tl.querySelectorAll('.tls'), function (s, i) { s.style.transitionDelay = (i * 110) + 'ms'; io.observe(s); });
  } catch (e) { if (window.console) console.warn('[nlx] block failed:', e); }
})();

var NLX_MONEY = (function () {
  var CFG = window.__NLX || {};
  var FMT = (function (probe) {
    if (!probe) return null;
    var m = String(probe).match(/\d[\d.,' \u00a0\u202f]*\d|\d/);
    if (!m) return null;
    var core = m[0];
    var tail = core.match(/([^\d])(\d{2})$/);
    var dec = tail ? tail[1] : '';
    var rest = tail ? core.slice(0, core.length - 3) : core;
    var grp = (rest.replace(/\d/g, '')[0]) || '';
    return { pre: String(probe).slice(0, m.index), suf: String(probe).slice(m.index + core.length), dec: dec, grp: grp, places: dec ? 2 : 0 };
  })(CFG.probe);
  function group(cents, sep, dec, places) {
    var parts = (Math.abs(cents) / 100).toFixed(places).split('.');
    if (sep) parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return parts.length > 1 ? parts.join(dec) : parts[0];
  }
  return function (cents) {
    if (FMT) return FMT.pre + group(cents, FMT.grp, FMT.dec, FMT.places) + FMT.suf;
    return '$' + group(cents, ',', '.', 2);
  };
})();

(function () {
  try {
    var CFG = window.__NLX || {};
    var money = NLX_MONEY;
    var UNIT = CFG.price || 0, FLOOR = CFG.floor || 0, T2 = +CFG.t2 || 0, T3 = +CFG.t3 || 0;
    var $ = function (id) { return document.getElementById(id); };
    var radios = [].slice.call(document.querySelectorAll('#nl-offers [data-tier-input]'));
    if (!radios.length) return;
    var addonIn = $('nl-addon-in');
    var ADDON = addonIn ? (+addonIn.getAttribute('data-price') || 0) : 0;
    var finQty = document.querySelector('[data-fin-qty]');
    var finTot = document.querySelector('[data-fin-total]');
    var finSub = document.querySelector('[data-fin-sub]');
    var finSubDefault = !finSub ? '' : finSub.hasAttribute('data-default') ? finSub.getAttribute('data-default') : finSub.textContent;
    var qty3 = 3;

    function pctFor(q) { return q >= 3 ? T3 : q === 2 ? T2 : 0; }
    function lineTotal(q) { var g = UNIT * q; return g - Math.round(g * pctFor(q) / 100); }
    function firstFree() { for (var q = 1; q < 50; q++) { if (lineTotal(q) >= FLOOR) return q; } return null; }
    function selected() {
      var r = radios.filter(function (x) { return x.checked; })[0] || radios[0];
      var tier = r.closest('.offer').getAttribute('data-tier');
      return { tier: tier, qty: tier === '3' ? qty3 : (parseInt(r.value, 10) || 1) };
    }

    function paint() {
      var sel = selected();
      var product = lineTotal(sel.qty);
      var total = product + (addonIn && addonIn.checked ? ADDON : 0);

      var t3in = $('nl-t3-input'); if (t3in) t3in.value = qty3;
      if ($('nl-qty')) $('nl-qty').textContent = qty3;
      if ($('nl-t3-total')) $('nl-t3-total').textContent = money(lineTotal(qty3));
      if ($('nl-t3-each')) $('nl-t3-each').textContent = money(Math.round(lineTotal(qty3) / qty3));
      var t3free = FLOOR > 0 && lineTotal(qty3) >= FLOOR;
      if ($('nl-t3-ship')) $('nl-t3-ship').hidden = !t3free;
      if ($('nl-t3-was')) $('nl-t3-was').textContent = money(UNIT * qty3);
      if ($('nl-t3-saved')) $('nl-t3-saved').textContent = money(UNIT * qty3 - lineTotal(qty3));
      if ($('nl-t3-name')) $('nl-t3-name').textContent = (qty3 === 3 ? '3+ ' : qty3 + ' ') + NLX_T.nouns;
      if ($('nl-t3-nudge')) {
        var more = 0;
        if (FLOOR > 0 && !t3free) { for (var n = 1; n <= 2; n++) { if (lineTotal(qty3 + n) >= FLOOR) { more = n; break; } } }
        $('nl-t3-nudge').hidden = !more;
        if (more && $('nl-t3-nudge-n')) $('nl-t3-nudge-n').textContent = more;
      }
      if ($('nl-minus')) $('nl-minus').disabled = qty3 <= 3;

      var label = document.querySelector('#nl-atc [data-atc-label]');
      if (label && !label.hasAttribute('data-busy') && !$('nl-atc').disabled) {
        label.textContent = nlxFmt(NLX_T.atc, { total: money(total) });
      }
      if (finQty) finQty.value = sel.qty;
      if (finTot) finTot.textContent = money(product);
      if (finSub) finSub.textContent = sel.qty > 1 ? nlxFmt(NLX_T.finSub, { qty: sel.qty, nouns: NLX_T.nouns, each: money(Math.round(product / sel.qty)) }) : finSubDefault;

      var prog = $('nl-ship-progress'), won = $('nl-ship-won');
      if (FLOOR > 0 && prog && won) {
        var free = total >= FLOOR;
        prog.hidden = free; won.hidden = !free;
        $('nl-ship').classList.toggle('ship--won', free);
        if (!free) {
          $('nl-ship-gap').textContent = nlxFmt(NLX_T.more, { amount: money(FLOOR - total) });
          $('nl-ship-now').textContent = money(total);
          $('nl-ship-fill').style.width = Math.min(100, total / FLOOR * 100).toFixed(1) + '%';
          var ff = firstFree(), hint = $('nl-ship-hint');
          if (hint && ff) hint.textContent = (CFG.shipRate > 0 ? nlxFmt(NLX_T.shipOne, { rate: money(CFG.shipRate) }) : '') +
            nlxFmt(pctFor(ff) ? NLX_T.shipFreePct : NLX_T.shipFree, { qty: ff, nouns: NLX_T.nouns, pct: pctFor(ff), total: money(lineTotal(ff)) });
        }
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', paint); });
    if ($('nl-minus')) $('nl-minus').addEventListener('click', function (e) { e.preventDefault(); if (qty3 > 3) { qty3--; paint(); } });
    if ($('nl-plus')) $('nl-plus').addEventListener('click', function (e) { e.preventDefault(); if (qty3 < 24) { qty3++; paint(); } });
    if (addonIn) addonIn.addEventListener('change', paint);

    var def = String(CFG.defaultTier || '1');
    var start = radios.filter(function (r) { return r.value === def; })[0];
    if (start && !radios.some(function (r) { return r.checked && r !== radios[0]; })) start.checked = true;
    paint();
  } catch (e) { if (window.console) console.warn('[nlx] block failed:', e); }
})();

(function () {
  try {
    var forms = [].slice.call(document.querySelectorAll('.nlx form[action$="/cart/add"]'))
      .filter(function (f) { return f.querySelector('[data-atc]'); });
    if (!forms.length) return;

    function qtyOf(form) {
      var i = form.querySelector('input[name="quantity"]:checked') || form.querySelector('input[name="quantity"]:not([type="radio"])');
      return Math.max(1, parseInt(i && i.value, 10) || 1);
    }
    function fail(form, msg) {
      var box = form.querySelector('[data-atc-error]');
      if (!box) return;
      box.textContent = msg || '';
      box.hidden = !msg;
    }
    function add(form, btn) {
      var label = btn.querySelector('[data-atc-label]') || btn;
      var prev = label.innerHTML;
      var id = form.querySelector('[name="id"]');
      if (!id) return;
      var addonIn = document.getElementById('nl-addon-in');
      var main = form.getAttribute('id') === 'nl-form'; // form.id is shadowed by the input named "id"
      var items = [{ id: +id.value, quantity: qtyOf(form) }];
      if (main && addonIn && addonIn.checked) items.push({ id: +addonIn.getAttribute('data-variant'), quantity: 1 });

      fail(form, '');
      btn.disabled = true;
      label.setAttribute('data-busy', '');
      label.textContent = NLX_T.adding;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || NLX_T.atcError);
            return fetch(window.Shopify.routes.root + 'cart.js').then(function (c) { return c.json(); });
          });
        })
        .then(function (cart) {
          if (window.emit) {
            window.emit('cart:updated', { cart: cart });
            window.emit('quick-cart:updated');
            window.emit('quick-cart:open');
          } else {
            window.location.href = window.Shopify.routes.root + 'cart';
            return;
          }
          label.textContent = NLX_T.added;
          setTimeout(function () { label.innerHTML = prev; label.removeAttribute('data-busy'); btn.disabled = false; }, 1800);
        })
        .catch(function (e) {
          fail(form, e.message || NLX_T.atcError);
          label.innerHTML = prev; label.removeAttribute('data-busy'); btn.disabled = false;
        });
    }

    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var btn = form.querySelector('[data-atc]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        add(form, btn);
      });
    });

    var sticky = document.querySelector('.nlx [data-sticky-atc]');
    if (sticky) sticky.addEventListener('click', function () {
      var f = forms[0], b = f.querySelector('[data-atc]');
      if (b && !b.disabled) add(f, b);
    });
  } catch (e) { if (window.console) console.warn('[nlx] block failed:', e); }
})();

(function () {
  try {
    var stage = document.getElementById('nl-stage');
    var main = document.getElementById('nl-main');
    var hv = document.getElementById('nl-hero-vid');
    var ctl = document.getElementById('nl-vidctl');
    var thumbs = [].slice.call(document.querySelectorAll('.nlx .media__rail .thumb'));
    if (!stage) return;

    function setCtl(paused) {
      if (!ctl) return;
      ctl.setAttribute('aria-pressed', paused ? 'true' : 'false');
      ctl.setAttribute('aria-label', paused ? NLX_T.play : NLX_T.pause);
    }
    function play(v) { var p = v.play(); if (p && p.catch) p.catch(function () { setCtl(true); }); setCtl(false); }

    if (hv) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) {
        hv.removeAttribute('autoplay'); hv.pause(); setCtl(true);
      }
      if (ctl) ctl.addEventListener('click', function () {
        if (hv.paused) play(hv); else { hv.pause(); setCtl(true); }
      });
    }

    function mark(t) {
      thumbs.forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        mark(t);
        if (t.hasAttribute('data-hero-video') && hv) {
          if (main) main.hidden = true;
          hv.hidden = false; if (ctl) ctl.hidden = false;
          play(hv);
        } else if (main) {
          if (hv) { hv.pause(); hv.hidden = true; if (ctl) ctl.hidden = true; }
          main.hidden = false;
          main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.removeAttribute('loading');
          main.src = t.getAttribute('data-src'); main.alt = t.getAttribute('data-alt') || '';
        }
      });
    });
  } catch (e) { if (window.console) console.warn('[nlx] block failed:', e); }
})();

(function () {
  try {
    var btn = document.querySelector('.nlx .vid__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      if (!src) return;
      var v = document.createElement('video');
      v.src = src; v.controls = true; v.autoplay = true; v.playsInline = true; v.setAttribute('playsinline', '');
      btn.replaceWith(v);
    });
  } catch (e) { if (window.console) console.warn('[nlx] block failed:', e); }
})();

(function () {
  try {
    var bar = document.querySelector('.nlx [data-sticky-bar]');
    var atc = document.getElementById('nl-atc');
    var fin = document.getElementById('buy');
    if (!bar || !atc || !('IntersectionObserver' in window)) return;
    var btn = bar.querySelector('[data-sticky-atc]'), gone = false, seen = false;
    function apply() {
      var on = gone && !seen;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { gone = !e.isIntersecting && e.boundingClientRect.top < 0; }); apply(); }).observe(atc);
    if (fin) new IntersectionObserver(function (es) { es.forEach(function (e) { seen = e.isIntersecting; }); apply(); }, { threshold: 0.15 }).observe(fin);
  } catch (e) { if (window.console) console.warn('[nlx] block failed:', e); }
})();
